<div class="relative inline-flex">
  <button
    id="header-notifications-toggle"
    type="button"
    class="relative inline-flex size-9 items-center justify-center rounded border border-transparent text-gray-700 transition hover:bg-gray-100 focus:bg-gray-100 focus:outline-hidden"
    aria-haspopup="menu"
    aria-controls="header-notifications-menu"
    [attr.aria-expanded]="open()"
    aria-label="Notificações"
    (click)="handleToggle()"
  >
    <i class="bi bi-bell text-lg leading-none" aria-hidden="true"></i>
    @if (unreadCount() > 0) {
    <span
      class="absolute -top-0.5 -end-0.5 flex size-[18px] items-center justify-center rounded-full bg-red-500 text-[10px] font-bold leading-none text-white ring-2 ring-white"
      aria-hidden="true"
    >
      {{ unreadBadgeLabel(unreadCount()) }}
    </span>
    }
  </button>

  <div
    id="header-notifications-menu"
    class="absolute end-0 z-60 mt-[40px] w-[min(24rem,calc(100vw-1rem))] rounded-lg border border-gray-200 bg-white shadow-lg transition-all duration-200 ease-out"
    role="menu"
    aria-labelledby="header-notifications-toggle"
    [ngClass]="{
      'pointer-events-none translate-y-1 opacity-0': !open(),
      'translate-y-0 opacity-100': open(),
    }"
  >
    <div
      class="flex items-center justify-between gap-3 border-b border-gray-200 px-4 py-3"
    >
      <h2 class="text-base font-semibold text-gray-900">Notificações</h2>
      @if (unreadCount() > 0) {
      <span
        class="inline-flex shrink-0 rounded-full px-2.5 py-0.5 text-xs font-medium"
        [ngClass]="unreadPillClass"
      >
        {{ unreadCount() }} não lidas
      </span>
      }
    </div>

    <ul class="max-h-[22rem] divide-y divide-gray-100 overflow-y-auto">
      @if (items().length === 0) {
      <li class="px-4 py-6 text-center text-sm text-gray-500">
        Nenhuma notificação nova.
      </li>
      } @else { @for (item of items(); track item.id) {
      <li>
        <div
          class="group flex items-start gap-3 px-4 py-3 transition hover:bg-gray-50"
          role="menuitem"
          [class.cursor-pointer]="!!item.actionUrl"
          (click)="handleNavigate(item.id, item.actionUrl, $event)"
        >
          <span
            class="mt-0.5 inline-flex size-9 shrink-0 items-center justify-center rounded-full"
            [ngClass]="iconToneClass(item.tone)"
            aria-hidden="true"
          >
            <i
              class="bi text-base leading-none"
              [class]="'bi-' + item.iconClass"
            ></i>
          </span>

          <div class="min-w-0 flex-1">
            <p class="text-sm font-semibold text-gray-900">
              {{ item.title }} @if (item.highlight) {
              <span [ngClass]="highlightClass(item.highlightTone ?? item.tone)">
                {{ item.highlight }}
              </span>
              }
            </p>
            <p class="mt-0.5 text-xs leading-relaxed text-gray-500">
              {{ item.description }}
            </p>
          </div>

          <button
            type="button"
            class="inline-flex size-7 shrink-0 items-center justify-center rounded text-gray-400 opacity-0 transition hover:bg-gray-100 hover:text-red-600 group-hover:opacity-100 focus:opacity-100 focus:outline-hidden"
            aria-label="Enviar para a lixeira"
            title="Enviar para a lixeira"
            (click)="handleDismiss(item.id, $event)"
          >
            <i class="bi bi-trash text-xs leading-none" aria-hidden="true"></i>
          </button>
        </div>
      </li>
      } }
    </ul>

    <div class="border-t border-gray-200 p-3">
      <a
        [routerLink]="viewAllRoute()"
        class="inline-flex w-full items-center justify-center rounded-md bg-[var(--color-primary)] px-4 py-2.5 text-sm font-medium text-white transition hover:bg-[var(--color-primary-hover)]"
        (click)="handleClose()"
      >
        Ver todas
      </a>
    </div>
  </div>
</div>
